import {Component} from 'react';
import React from 'react';
import ReactTable from 'react-table';
import Badge from 'react-bootstrap/lib/Badge';

class CardSub extends Component {
    constructor(props) {
        /*
            Props:
             - card
        */
        super(props);
    }
    
    render() {
        return (
            <div className="p-5">
                <h3><i className="mdi mdi-history"/> History: </h3>
                <ReactTable
                    defaultSorted={[
                        {
                            id: "timestamp",
                            desc: true
                        }
                    ]}
                    data={this.props.card.history}
                    /*getTdProps={(state, rowInfo, column, instance) => {
                        if(rowInfo!=null && column.Header!=='Delete') return {
                            style: {
                                cursor: 'pointer'
                            },
                            onClick: e => {
                                console.log("Cell - onClick", rowInfo.original);
                                this.setState({
                                    addCardOpen: true,
                                    editCard: rowInfo.original
                                });
                            }
                        };
                        return {};
                    }}*/
                    columns={[
                        {
                            Header: "Date",
                            accessor: "timestamp",
                            Cell: row => {
                                return new Date(row.original.timestamp).toLocaleString();
                            },
                            filterable: false
                        },
                        {
                            Header: "Description",
                            accessor: "description"
                        },
                        {
                            Header: "Amount",
                            accessor: "amount",
                            Cell: row => (<Badge>{row.original.amount>0 ? "+"+row.original.amount.toFixed(2)+" "+this.props.currency : row.original.amount.toFixed(2)+" "+this.props.currency}</Badge>),
                            filterable: false
                        }
                    ]}
                    filterable
                    defaultPageSize={5}
                    className="-striped -highlight"
                />
            </div>
        );
    }
}

export default CardSub;